<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "../../router/index.js";
import {listServiceItem, deleteServiceItem} from "@/api/serviceItem/serviceItem.js";

/*初次加载*/
onMounted(() => {
  handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  name: null,
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listServiceItem(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.name = null
  formData.phone = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  {title: '名称', key: 'name', width: "120px", nowrap: true},
  {title: '类型', key: 'type', width: "150px", nowrap: true},
  {title: '时间', key: 'time', width: "250px", nowrap: true},
  {title: '关联项目', key: 'bizName', width: "150px", nowrap: true},
  {title: '操作', key: 'controls', width: "100px", fixed: true},
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 添加服务项目
const handleAdd = () => {
  router.push({ path: 'editServiceItems' })
}

/*操作栏功能*/
// 排班
const toSchedule = async (info) => {
  router.push({path: "/arrangeServiceItems", query: {serviceItemId: info.serviceItemId, serviceItemType: info.type}})
}
// 编辑
const handleEdit = (info) => {
  router.push({path: '/editServiceItems', query: {serviceItemId: info.serviceItemId}})
}
// 删除
const dialogConfirm = async (info) => {
  try {
    loading.value = true
    await deleteServiceItem(info.serviceItemId)
    ElMessage.success('删除成功')
    loading.value = false
    await handleSearch()
  } catch (error) {
    loading.value = false
    ElMessage.error('删除失败')
  }
}

</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd">新建服务项目
      </v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.name"
                        placeholder="请输入服务项目名"
                        label="服务项目名称"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="6">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索
                        </v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset">重置
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.type="{item}">
            <div v-if="item.type === 'THERAPY'">理疗</div>
            <div v-else>摄影摄像</div>
          </template>

          <template v-slot:item.time="{ item }">
            <div v-if="item.startTime && item.endTime">{{item.startTime}} - {{item.endTime}}</div>
            <div v-else> - </div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left flex_align_b">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="排班"
                  placement="left">
                <v-icon class="cursor-pointer mg_r_1" icon="mdi-clock-outline" size="small" color="primary" @click="toSchedule(item)"></v-icon>
              </el-tooltip>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="top">
                <v-icon class="cursor-pointer mg_r_1" icon="mdi-file-edit-outline" size="small" color="primary" @click="handleEdit(item)"></v-icon>
              </el-tooltip>
              <el-popconfirm @confirm="dialogConfirm(item)" :title="`确定删除服务项目 “${item.name}” 吗？`">
                <template #reference>
                  <div>
                    <el-tooltip
                      class="box-item"
                      effect="dark"
                      content="删除"
                      placement="top">
                      <v-icon class="cursor-pointer mg_r_1" icon="mdi-trash-can-outline" size="small" color="warning"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :page-size="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>
